/* unplugin-vue-components disabled */import { render } from "./AsideOrderSummary.vue?vue&type=template&id=c61c05f8&ts=true"
import script from "./AsideOrderSummary.vue?vue&type=script&lang=ts"
export * from "./AsideOrderSummary.vue?vue&type=script&lang=ts"

import "./AsideOrderSummary.vue?vue&type=style&index=0&id=c61c05f8&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__